/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type Product_item = {
    readonly isAuctionEnabled: boolean | null;
    readonly productPhotos: ReadonlyArray<{
        readonly placeholder: string | null;
        readonly smallPath: string | null;
        readonly masterOrZoomPath: string | null;
        readonly versions: ReadonlyArray<{
            readonly webPath: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"AuctionCountdown_item">;
    readonly " $refType": "Product_item";
};
export type Product_item$data = Product_item;
export type Product_item$key = {
    readonly " $data"?: Product_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Product_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "searchAndBrowse",
      "kind": "LocalArgument",
      "name": "pageDisplayEnum"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "photosLimit"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Product_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": "productPhotos",
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "placeholder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "smallPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "masterOrZoomPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "kind": "LinkedField",
          "name": "versions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webPath",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "pageDisplayEnum"
        }
      ],
      "kind": "FragmentSpread",
      "name": "AuctionCountdown_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'f4399edb3c3defa7475f21c9501d6bbe';
export default node;
